import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = {
    key: 0,
    class: "row no-gutters w-100 bg-white"
};
const _hoisted_4 = { class: "col-12 px-lg-5 pb-2 mt-3" };
const _hoisted_5 = {
    key: 0,
    class: "row"
};
const _hoisted_6 = { class: "col-12 mb-3" };
const _hoisted_7 = {
    key: 1,
    class: "row no-gutters",
    style: { "max-height": "2px", "border-top": "1px dotted #000" }
};
const _hoisted_8 = { class: "row mapsWrapper" };
const _hoisted_9 = {
    class: "col-md-8 pr-md-2 mapDimensions overflow-auto",
    style: { "z-index": "2" }
};
const _hoisted_10 = {
    key: 0,
    class: "row no-gutters w-100 bg-white overflow-hidden"
};
const _hoisted_11 = {
    class: "w-100 bg-white pt-2",
    style: { "height": "110px", "z-index": "2" }
};
const _hoisted_12 = {
    key: 0,
    class: "w-100 mx-3",
    style: { "max-height": "1px", "border-top": "1px dotted #000" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_locations_map_input_fields = _resolveComponent("locations-map-input-fields");
    const _component_google_maps = _resolveComponent("google-maps");
    const _component_location_card = _resolveComponent("location-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_locations_map_input_fields, { onShowList: _ctx.startShowStoreList }, null, 8, ["onShowList"])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["d-inline-block pointerhover switchButton toList mr-2 mb-1", !_ctx.showMapsNotListing ? 'active' : '']),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showMapsNotListing = false))
                        }, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("img", {
                                    src: "images/store_pages/list.svg",
                                    alt: "list"
                                }, null, -1),
                                _createTextVNode(" LISTE ", -1)
                            ]))], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["d-inline-block pointerhover switchButton toMap mb-1", _ctx.showMapsNotListing ? 'active' : '']),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showMapsNotListing = true))
                        }, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("img", {
                                    src: "images/store_pages/pin.svg",
                                    alt: "list"
                                }, null, -1),
                                _createTextVNode(" KARTE ", -1)
                            ]))], 2)
                    ])
                ]))
                : _createCommentVNode("", true),
            (!_ctx.showMapsNotListing && _ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " "))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_google_maps, {
                        renderer: _ctx.clusterRenderer,
                        "geo-points": _ctx.locations
                    }, null, 8, ["renderer", "geo-points"])
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mapDimensions pl-md-1", { shopListWrapperVorne: !_ctx.showMapsNotListing, 'position-absolute': _ctx.smallDisplay }]),
                    style: { "z-index": "1", "overflow-y": "auto", "overflow-x": "hidden" }
                }, [
                    (!_ctx.smallDisplay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_locations_map_input_fields, { onShowList: _ctx.startShowStoreList }, null, 8, ["onShowList"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.showStoreList)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["row no-gutters bg-white overflow-auto pr-md-3", { bgGray: !_ctx.showMapsNotListing, fullHeight: !_ctx.showMapsNotListing }]),
                            style: { "height": "calc(100% - 110px)" }
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                                return (_openBlock(), _createBlock(_component_location_card, {
                                    location: location,
                                    ref_for: true,
                                    ref: 'location-card-' + location.id,
                                    key: index
                                }, null, 8, ["location"]));
                            }), 128))
                        ], 2))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["p-4 text-center bgGray row no-gutters strong", { fullHeight: !_ctx.showMapsNotListing }]),
                            style: { "height": "calc(100% - 110px)" }
                        }, " Bitte gib eine PLZ ein, um Stores in deiner Nähe aufzulisten! ", 2))
                ], 2)
            ])
        ]),
        (!_ctx.showMapsNotListing && _ctx.smallDisplay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "   "))
            : _createCommentVNode("", true)
    ]));
}
